/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_ALL_GEOS, SET_SELECTED_GEO, SET_NO_GEO, SET_SELECTED_INSTANCE, GET_ALL_ENV_TYPES } from "./types";

const initialState = {
  geos: [],
  selectedGeo: '',
  noGeo: false,
  envTypes: [],
  noEnvTupe: false,
  selectedInstance: '',
};

export const systemSpecReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_GEOS:
      return {
        ...state,
        geos: action.geos,
        noGeo: action.noGeo,
      };
    case SET_SELECTED_GEO:
      return {
        ...state,
        selectedGeo: action.selectedCustomer,
      };
    case SET_NO_GEO:
      return {
        ...state,
        noGeo: action.noGeo,
      };
    case GET_ALL_ENV_TYPES:
      return {
        ...state,
        envTypes: action.envTypes,
        noEnvType: action.noEnvType,
      };
    case SET_SELECTED_INSTANCE:
      return {
        ...state,
        selectedInstance: action.selectedInstance,
      };
    default:
      return state;
  }
};
